import api from './axios';

export const getSystemLogs = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.page) params.append('page', String(filters.page));
  if (filters.limit) params.append('limit', String(filters.limit));
  if (filters.level) params.append('level', String(filters.level));
  if (filters.action) params.append('action', String(filters.action));
  if (filters.q) params.append('q', String(filters.q));
  if (filters.tenant_id) params.append('tenant_id', String(filters.tenant_id));
  if (filters.user_id) params.append('user_id', String(filters.user_id));
  if (filters.from) params.append('from', String(filters.from));
  if (filters.to) params.append('to', String(filters.to));
  const query = params.toString();
  const suffix = query ? `?${query}` : '';
  const response = await api.get(`/system-logs${suffix}`);
  return response.data;
};

export const trackPageView = async (path) => {
  if (!path) return;
  await api.post('/system-logs/page-view', { path });
};

